import { useEffect, useRef } from "react";

const LoadMoreTrigger = ({ onVisible }: { onVisible: () => void }) => {
  const ref = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) onVisible();
      },
      { threshold: 1 }
    );

    const currentElement = ref.current;
    if (currentElement) observer.observe(currentElement);

    return () => {
      if (currentElement) observer.unobserve(currentElement);
    };
  }, [onVisible]);

  return <div ref={ref} style={{ height: "50px" }} />;
};

export default LoadMoreTrigger;
